(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('HomeBranchIfscUpload', HomeBranchIfscUpload);

    HomeBranchIfscUpload.$inject = ['$resource'];

    function HomeBranchIfscUpload($resource) {
        var resourceUrl =  'api/home-branch-upload';

        return $resource(resourceUrl, {}, {
        	   'generateTemplateFile': {
                   method: 'POST',
                   url: 'api/home-branch-template-export',
                   responseType: 'arraybuffer',
                   transformResponse: function(data, headers) {
                 	  return {
                           data: data,
                           headers: headers
                       };   
                   }         
              }
            
            
              });
    }
})();

            
